import { halfPageManagerState as state } from './halfPageManagerState';
import * as consts from './halfPageManagerConstants';
import * as els from './halfPageManagerElements';

export const halfPageManagerUpdateRepeaterHeights = (): void => {
  const repeaterBannerList: Array<HTMLElement> = state.getRepeaterBannerList();

  // Všem repeater bannerům nastavíme defaultní výšku
  repeaterBannerList.forEach((banner, index) => {
    const isLast = index === repeaterBannerList.length - 1;

    // Poslednímu banneru nastavíme zbylou výšku bočního bloku
    banner.style.height = `${
      isLast ? state.getLastBannerHeight() : consts.HALFPAGE_WRAPPER_DEFAULT_HEIGHT
    }px`;
  });

  // Aktualizujeme výšku topBanneru s miniplayerem
  if (els.topAside && els.topBanner) {
    const miniplayerHeight = els.miniplayer?.offsetHeight || 0;
    const currentHeight = parseInt(els.topBanner.style.height, 10) || 0;
    if (currentHeight > 0) {
      els.topBanner.style.height = `${currentHeight + miniplayerHeight}px`;
    }
  }
};
